'use client'

import { Tooltip as HeroTooltip } from '@heroui/react'
import { createContext, useContext, useEffect, useState } from 'react'
import type { ComponentProps, ReactNode } from 'react'

type PlatformTooltipsContextValue = {
    enabled: boolean
    setEnabled: (enabled: boolean) => void
    openSettings: () => void
    settingsOpen: boolean
    setSettingsOpen: (open: boolean) => void
}

const PlatformTooltipsContext = createContext<PlatformTooltipsContextValue | null>(null)

export function PlatformTooltipsProvider({ children, initialEnabled }: { children: ReactNode, initialEnabled: boolean }) {
    const [enabled, setEnabled] = useState(initialEnabled)
    const [settingsOpen, setSettingsOpen] = useState(false)

    useEffect(() => setEnabled(initialEnabled), [initialEnabled])

    return (
        <PlatformTooltipsContext.Provider value={{ enabled, setEnabled, openSettings: () => setSettingsOpen(true), settingsOpen, setSettingsOpen }}>
            {children}
        </PlatformTooltipsContext.Provider>
    )
}

export function usePlatformTooltips() {
    return useContext(PlatformTooltipsContext)
}

export function Tooltip({ children, ...props }: ComponentProps<typeof HeroTooltip>) {
    const settings = usePlatformTooltips()
    if (settings?.enabled === false) return <>{children}</>
    return <HeroTooltip {...props}>{children}</HeroTooltip>
}
